import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";

const OrgLoginScreen = ({ login, isLoggedIn }) => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if ( isLoggedIn ) {
      navigate("/")
    }

    window.scrollTo(0, 0);
  }, [isLoggedIn, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    login(username, password);
  };

  return (
    <Container className="auth-page">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="auth-card">
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <h3 className="page-title">Organisation Login</h3>
                <p className="page-subtitle mb-4">Access your school or organisation account dashboard.</p>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Username</Form.Label>
                  <Form.Control required placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} tabIndex={1}/>
                </Form.Group>
                <Form.Group className="mb-4" controlId="formPassword">
                  <Form.Label>Password <Link className="ms-2" to="/org-forgot-password">Forgot Password?</Link></Form.Label>
                  <Form.Control type="password" required placeholder="Enter password" autoComplete="true" value={password} onChange={(e) => setPassword(e.target.value)} tabIndex={2}/>
                </Form.Group>
                <Button variant="primary" type="submit" tabIndex={3}>
                  Login
                </Button>

                <Form.Text className="auth-links" muted>
                  Don't have an account? View school courses <Link to="/schools-and-teachers" tabIndex={4}>here</Link>
                </Form.Text>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OrgLoginScreen;
